import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { InitialLoaderService } from './app/services/initial-loader/initial-loader';

bootstrapApplication(App, appConfig).catch((err) => {
  InitialLoaderService.showError();
  console.error(err);
});
